<div
  class="flex flex-wrap items-center border border-gray-300 rounded p-1"
  [formGroup]="groupName()"
  #origin="cdkOverlayOrigin"
  cdkOverlayOrigin
  #searchInput
>
  @if (isMultiSelect()) {
  <div>
    @for (selectedOption of selectedOptions; track selectedOption; let i =
    $index) {
    <div class="flex items-center bg-blue-500 text-white rounded p-1 mr-1 mb-1">
      {{ selectedOption.label }}
      <button
        type="button"
        class="ml-1 text-white"
        (click)="removeSelectedOption(i)"
      >
        ✕
      </button>
    </div>
    }
  </div>
  }
  <div class="w-full relative text-neutral-50 grid" (click)="openInput()">
    <div
      class="max-w-full bg-white gridArea overflow-hidden whitespace-nowrap ml-[2px] mr-[2px] box-border flex items-center"
      [ngClass]="{ hidden: isInputFocused && searchControl.value !== '' }"
    >
      {{ selectedOptions.length ? selectedOptions[0].label : 'Select...' }}
    </div>

    <input
      #inputRef
      [formControl]="searchControl"
      type="text"
      placeholder="Type to search..."
      (focus)="openPanel()"
      [style.visibility]="!isInputFocused ? 'hidden' : 'visible'"
      (focus)="!isMultiSelect() && openPanel(); isInputFocused = true"
      (blur)="isInputFocused = false"
      aria-haspopup="true"
      class="w-full border-none gridArea outline-none focus:!border-none focus:!outline-none focus:!shadow-inherit"
    />
    <ng-icon
      name="heroChevronDown"
      class="absolute right-2 top-2 cursor-pointer"
      size="16"
      (click)="toggleOverlay()"
    ></ng-icon>
  </div>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayPositions]="positions"
    [cdkConnectedOverlayOpen]="panelOpen"
    (detach)="panelOpen = false"
    (outsideClick)="panelOpen = false"
  >
    <div
      class="bg-white flex flex-col gap-2 text-neutral-50 border-neutral-90 border rounded-lg w-full h-72 overflow-y-scroll"
      role="listbox"
    >
      @for (option of filteredOptions; track option; let i = $index) {
      <div
        (click)="selectOption(option)"
        class="hover:bg-purple-99 py-2 px-4"
        role="option"
      >
        {{ option.label }}
      </div>
      }
    </div>
  </ng-template>
</div>
